import { createRouter, createWebHistory } from "vue-router";
// 新架构组件
import HomePage from "../views/HomePage.vue";
import TopicPage from "../views/TopicPage.vue";
// 旧组件（保留兼容）
import Index from "../views/index.vue";
import BlogDetail from "../views/blog_detail.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage, // 使用新的 HomePage
  },
  {
    path: "/topic/:topicId",
    name: "TopicPage",
    component: TopicPage,
  },
  {
    path: "/blog/:id",
    name: "BlogDetail",
    component: BlogDetail,
  },
  {
    path: "/old", // 旧版本保留用于对比
    name: "IndexOld",
    component: Index,
  },
  {
    path: "/bdtest",
    name: "BlogDetailTest",
    component: BlogDetail,
  },
  {
    path: "/:catchAll(.*)",
    name: "/404",
    component: () => import("../views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
